import { useState } from 'react'

const DEFAULT_INITIAL_VISIBLE_COUNT = 3

interface UseShowMoreOptions {
  initialVisibleCount?: number
}

export const useShowMore = <T>(
  items: T[],
  {
    initialVisibleCount = DEFAULT_INITIAL_VISIBLE_COUNT,
  }: UseShowMoreOptions = {}
) => {
  const [showAll, setShowAll] = useState(false)

  const visibleItems = showAll ? items : items.slice(0, initialVisibleCount)
  const hiddenCount = Math.max(0, items.length - initialVisibleCount)
  const hasHidableItems = items.length > initialVisibleCount

  const toggleShowAll = () => setShowAll(!showAll)

  return {
    visibleItems,
    hiddenCount,
    hasHidableItems,
    toggleShowAll,
    showAll,
  }
}
